import { Component, OnInit, ViewChild } from "@angular/core";
import { TaskService } from "../../master-services/tasks/task.service";
import { ITaskLine } from "../../master-models/task.model";
import swal from "sweetalert2";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";

@Component({
  selector: "app-task-lines-management",
  templateUrl: "./task-lines-management.component.html",
  styleUrls: [
    "./task-lines-management.component.scss",
    '../../../assets/icon/icofont/css/icofont.scss'
  ],
})
export class TaskLinesManagementComponent implements OnInit {
  taksLines: ITaskLine[] = [];
  lineIdToEdit: number = 0;
  newLine: string = '';

  @ViewChild('modalFormLine') modalFormLine: ModalBasicComponent;

  constructor(private taskService: TaskService) {}

  ngOnInit() {
    this.getTaskLines();
  }

  getTaskLines() {
    this.taskService.getTaskLines().subscribe(
      (data) => {
        this.taksLines = data.data;
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al obtener las líneas',
          text: 'Ocurrió un error al intentar obtener las líneas',
          type: 'error',
        });
      }
    );
  }

  toggleLineForm(lineId: number = 0) {
    if (this.modalFormLine.visible) {
      this.modalFormLine.hide();
      this.newLine = '';
      this.lineIdToEdit = 0;
      return;
    }

    this.lineIdToEdit = lineId;
    if (lineId) {
      const line = this.taksLines.find(l => l.id === lineId);
      if (line) {
        this.newLine = line.name;
      }
    }
    this.modalFormLine.show();
  }

  createLine() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newLine) {
      swal({
        title: 'Por favor ingrese el nueva linea',
        text: 'Debe ingresar una descripcion valida para la linea',
        type: 'error'
      });
      return;
    }

    const newLineBody = { name: this.newLine };

    this.taskService.createTaskLine(newLineBody)
      .subscribe(
        data => {
          this.getTaskLines();
          swal({
            title: 'Linea agregada',
            type: 'success'
          });
          this.toggleLineForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al agregar la linea',
            text: 'Ocurrió un error al intentar agregar la nueva linea',
            type: 'error'
          });
        }
      );
  }

  updateLine() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newLine) {
      swal({
        title: 'Por favor ingrese la linea',
        text: 'Debe ingresar una descripcion valida para la linea',
        type: 'error'
      });
      return;
    }

    const lineBody = { name: this.newLine };

    this.taskService.updateTaskLine(this.lineIdToEdit, lineBody)
      .subscribe(
        data => {
          this.getTaskLines();
          swal({
            title: 'Linea modificada',
            type: 'success'
          });
          this.toggleLineForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar la linea',
            text: 'Ocurrió un error al intentar modificar la linea',
            type: 'error'
          });
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/master/task-lines-management/task-lines-management.component.ts